var exports = {
  "k": "xaf9ae18d--daae2a--container",
  "n": "xaf9ae18d--daae2a--link",
};

module.exports = exports;
